import uiFeatures from "../config/ui_features.json";

const normalizeStatus = (status) => {
  if (!status) return "disabled";
  const lowered = String(status).toLowerCase();
  if (lowered === "enabled" || lowered === "disabled" || lowered === "maintenance") {
    return lowered;
  }
  return "disabled";
};

export const getFeatureStatus = (featureName) => {
  const entry = featureName ? uiFeatures[featureName] : null;
  if (!entry) {
    return {
      status: "disabled",
      message: "Feature is not available.",
      maintenanceType: null,
      lastUpdated: null,
    };
  }
  return {
    status: normalizeStatus(entry.status),
    message: entry.message || "",
    maintenanceType: entry.maintenanceType ?? null,
    lastUpdated: entry.lastUpdated || null,
  };
};

export const isUiFeatureEnabled = (featureName) =>
  getFeatureStatus(featureName).status === "enabled";

export const isUiFeatureVisible = (featureName) => {
  const status = getFeatureStatus(featureName).status;
  return status === "enabled" || status === "maintenance";
};
